import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AnimalModel } from '../models/animal.model';
import { PickupReportPreviewPayload } from '../models/pickup-report-preview-payload.model';
import { FoundReportPreviewContactEntry } from '../models/found-report-preview-payload.model';
import { AnimalWhereaboutsType } from '../models/animal-wherabout-types.enum';

@Injectable({ providedIn: 'root' })
export class PickupReportPreviewBuilderService {
  constructor(private readonly datePipe: DatePipe) {}

  build(args: {
    animal: AnimalModel;
    formValue: any;
    shelterId: number;
    contacts: FoundReportPreviewContactEntry[];
  }): PickupReportPreviewPayload {
    const { animal, formValue, shelterId, contacts } = args;

    return {
      animal: {
        category: (animal as any)?.category ?? null,
        type: (animal as any)?.type ?? null,
        name: (animal as any)?.name ?? null,
        bookNumber: (animal as any)?.bookNumber ?? null,
        oldBookNumber: (animal as any)?.oldBookNumber ?? null,
        oldBookNumberList: (animal as any)?.oldBookNumberList ?? null,
        breed: (animal as any)?.breed ?? null,
        sex: (animal as any)?.sex ?? null,
        transponderNumber: (animal as any)?.transponderNumber ?? null,
        tattoo: (animal as any)?.tattoo ?? null,
        ringNumber: (animal as any)?.ringNumber ?? null,
        specialInformation: (animal as any)?.specialInformation ?? null,
        coatType: (animal as any)?.coatType ?? null,
        coatColor: (animal as any)?.coatColor ?? null,
        badge: (animal as any)?.badge ?? null,
        specialNotice: (animal as any)?.specialNotice ?? null,
      },
      animalWhereabout: {
        type: AnimalWhereaboutsType.FOUNDANIMAL_RETURN,
        date: formValue.pickUpDateTime,
        dateCare: null,
        information: null,
        discoverySource: null,
        shelterChanged: false,
        pickupContact: null,
        pickupSignature: formValue.pickupSignature ?? null,
        reportPdfPath: null,
        employeeSignature: formValue.employeeSignature ?? null,
        signatureLocation: formValue.signatureLocation ?? null,
        signatureDate: formValue.signatureDate,
        pickupDateTime: formValue.pickUpDateTime,
        bcsNutrition: (formValue.bcsNutrition ?? null) as string | null
      },
      contacts,
      animalShelter: { id: shelterId },
    };
  }
}
